import { writeFile } from "node:fs/promises"

export type WriteJsonConfig = {
    data: Record<string, unknown> | unknown[]
    output: string
}

export async function writeJson({ data, output }: WriteJsonConfig): Promise<void> {
    await writeFile(output, JSON.stringify(data, undefined, 4) + "\n", "utf-8")
}
